// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"7036947a","703":"76f6a214","787":"fb1339ef"}[chunkId] + ".chunk.js";
};